(function () {
  'use strict';

  var ANCHOR = 'get-expert-advice';
  var ATTRIBUTION_PARAM_KEYS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'fbclid',
    'msclkid',
    'ttclid',
    'li_fat_id',
    'gad_source'
  ];
  var ATTRIBUTION_STORAGE_KEYS = ['quiz_builder_attribution', 'primo_attribution'];

  function getAttributionStorage(primary, fallback) {
    try {
      if (window[primary]) return window[primary];
    } catch (error) {}
    try {
      if (window[fallback]) return window[fallback];
    } catch (error) {}
    return null;
  }

  function readAttributionStore(storage) {
    if (!storage) return {};
    try {
      var raw = storage.getItem('primo_attribution');
      if (!raw) raw = storage.getItem('quiz_builder_attribution');
      if (!raw) return {};
      var data = JSON.parse(raw);
      return data && typeof data === 'object' ? data : {};
    } catch (error) {
      return {};
    }
  }

  function writeAttributionStore(data) {
    if (!data) return;
    var json = JSON.stringify(data);
    var session = getAttributionStorage('sessionStorage', 'localStorage');
    var local = getAttributionStorage('localStorage', 'sessionStorage');

    ATTRIBUTION_STORAGE_KEYS.forEach(function (key) {
      if (session) {
        try { session.setItem(key, json); } catch (error) {}
      }
      if (local && local !== session) {
        try { local.setItem(key, json); } catch (error) {}
      }
    });
  }

  function captureAttribution(search) {
    if (typeof window === 'undefined') return getAttribution();

    var params;
    try {
      params = new URLSearchParams(search != null ? search : window.location.search);
    } catch (error) {
      return getAttribution();
    }

    var session = getAttributionStorage('sessionStorage', 'localStorage');
    var local = getAttributionStorage('localStorage', 'sessionStorage');
    var stored = readAttributionStore(session);
    if (!Object.keys(stored).length) stored = readAttributionStore(local);

    var changed = false;
    ATTRIBUTION_PARAM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      stored[key] = value;
      changed = true;
    });

    if (changed) {
      if (!stored.captured_at) stored.captured_at = new Date().toISOString();
      if (!stored.landing_url && window.location) stored.landing_url = window.location.href;
      writeAttributionStore(stored);
    }

    return getAttribution(stored);
  }

  function getAttribution(storedData) {
    var session = getAttributionStorage('sessionStorage', 'localStorage');
    var local = getAttributionStorage('localStorage', 'sessionStorage');
    var stored = storedData || readAttributionStore(session);
    if (!Object.keys(stored).length) stored = readAttributionStore(local);

    var result = {};
    ATTRIBUTION_PARAM_KEYS.forEach(function (key) {
      if (stored[key]) result[key] = stored[key];
    });
    if (stored.captured_at) result.captured_at = stored.captured_at;
    if (stored.landing_url) result.landing_url = stored.landing_url;
    return result;
  }

  function applyAttributionToPayload(payload) {
    var attribution = getAttribution();
    if (!Object.keys(attribution).length) return payload;

    payload.attribution = Object.assign({}, attribution);
    Object.keys(attribution).forEach(function (key) {
      payload[key] = attribution[key];
    });
    return payload;
  }

  function getSourceContext() {
    return {
      source_url: window.location.href,
      source_path: window.location.pathname,
      source_referrer: document.referrer || '',
      page_title: document.title || ''
    };
  }

  function init() {
    captureAttribution();
    document.querySelectorAll('[data-eh-enquiry-form]:not([data-eh-enquiry-bound])').forEach(bindForm);
    document.querySelectorAll('[data-eh-cta], a[href="#get-expert-help"], a[href="#get-expert-advice"]').forEach(function (el) {
      if (el.tagName !== 'A') return;
      var href = (el.getAttribute('href') || '').trim();
      // Keep external/quiz destinations intact. Only normalise empty or form-anchor CTAs.
      if (!href || href === '#' || href === '#get-expert-help' || href === '#get-expert-advice') {
        el.setAttribute('href', '#' + ANCHOR);
      }
    });
  }

  function bindForm(form) {
    form.dataset.ehEnquiryBound = 'true';
    var webhookUrl = (form.getAttribute('data-webhook-url') || '').trim();
    var redirectUrl = (form.getAttribute('data-redirect-url') || '').trim();
    var formSource = form.getAttribute('data-form-source') || 'Get Expert Advice LP';
    var body = form.querySelector('[data-eh-enquiry-body]');
    var success = form.querySelector('[data-eh-enquiry-success]');
    var submitBtn = form.querySelector('[data-eh-enquiry-submit]');
    var formError = form.querySelector('[data-eh-form-error]');

    function clearErrors() {
      form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
      form.querySelectorAll('[data-eh-field-error]').forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
      });
      if (formError) { formError.hidden = true; formError.textContent = ''; }
    }

    function setError(name, message) {
      var field = form.querySelector('[data-eh-field="' + name + '"]');
      var wrap = field && field.closest('[data-eh-field-wrap]');
      var err = wrap && wrap.querySelector('[data-eh-field-error]');
      if (wrap) wrap.classList.add('is-invalid');
      if (err) { err.textContent = message; err.hidden = false; }
    }

    function val(name) {
      var el = form.querySelector('[data-eh-field="' + name + '"]');
      return el ? el.value.trim() : '';
    }

    function validate() {
      clearErrors();
      var ok = true;
      if (!val('first_name')) { setError('first_name', 'First name is required.'); ok = false; }
      if (!val('last_name')) { setError('last_name', 'Last name is required.'); ok = false; }
      if (!val('email')) { setError('email', 'Email is required.'); ok = false; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))) { setError('email', 'Enter a valid email.'); ok = false; }
      if (!val('phone')) { setError('phone', 'Phone is required.'); ok = false; }
      if (!val('budget')) { setError('budget', 'Please select your budget.'); ok = false; }
      if (!val('proposal_date')) { setError('proposal_date', 'Please select your planned proposal timeline.'); ok = false; }
      return ok;
    }

    function payload() {
      var firstName = val('first_name');
      var lastName = val('last_name');
      var data = Object.assign(
        {
          form_source: formSource,
          name: [firstName, lastName].filter(Boolean).join(' ').trim(),
          first_name: firstName,
          last_name: lastName,
          email: val('email'),
          phone: val('phone'),
          budget: val('budget'),
          proposal_date: val('proposal_date'),
          planned_proposal_date: val('proposal_date'),
          submitted_at: new Date().toISOString()
        },
        getSourceContext()
      );

      return applyAttributionToPayload(data);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate()) return;
      if (!webhookUrl) {
        if (formError) {
          formError.textContent = 'Form is not configured. Please set a webhook URL.';
          formError.hidden = false;
        }
        return;
      }
      submitBtn.disabled = true;
      var data = payload();
      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data),
        keepalive: true
      })
        .then(function (res) {
          if (!res.ok) throw new Error('fail');
          if (redirectUrl) {
            window.location.assign(redirectUrl.replace('[FIRST NAME]', encodeURIComponent(data.first_name)));
            return;
          }
          if (body) body.hidden = true;
          if (success) {
            success.hidden = false;
            var nameEl = success.querySelector('[data-eh-success-name]');
            if (nameEl) nameEl.textContent = data.first_name;
          }
          form.dispatchEvent(new CustomEvent('eh:lead-submitted', { detail: data }));
        })
        .catch(function () {
          if (formError) {
            formError.textContent = 'Something went wrong. Please try again or call us.';
            formError.hidden = false;
          }
        })
        .finally(function () { submitBtn.disabled = false; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
